import React, { useContext, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage.js";
import CheckoutPage from "./pages/CheckoutPage.js";
import CheckoutReturnPage from "./pages/CheckoutReturnPage.js";
import ShippingPage from "./pages/ShippingPage.js";
import ShippingAddressPage from "./pages/ShippingAddressPage.js";
// import ProductDetailsPage from "./pages/ProductDetailsPage.js";
import B01ProductPage from "./pages/B01ProductPage.js";
import B01LiteProductPage from "./pages/B01LiteProductPage.js";
import H01ProductPage from "./pages/H01ProductPage.js";
import { Notice, LanguageSelection } from "./pages/NoticePage.js";
import CartPage from "./pages/CartPage.js";
import CreateAccount from "./pages/CreateAccount.js";
import LoginPage from "./pages/LoginPage.js";
import OrderLoginPage from "./pages/OrderLoginPage.js";
import BalteeStory from "./pages/BalteeStory.js";
import ContactPage from "./pages/ContactPage.js";
import BusinessPage from "./pages/BusinessPage.js";
import CitiesPage from "./pages/CitiesPage.js";
import ResellerPage from "./pages/ResellerPage.js";
import FAQPage from "./pages/FAQPage.js";
import CguPage from "./pages/CguPage.js";
import LegalNoticePage from "./pages/LegalNoticePage.js";
import CgvPage from "./pages/CgvPage.js";
import AccountPage from "./pages/AccountPage.js";
import OrderCreateAccount from "./pages/OrderCreateAccount.js";
import RentContract from "./pages/RentContract.js";
import NotFoundPage from "./pages/NotFoundPage.js";
import PoliciesPage from "./pages/PoliciesPage.js";
import TopMenu from "./menus/TopMenu.js";
import FooterMenu from "./menus/FooterMenu.js";
import { AuthContext } from "./contexts/AuthContext.js";
import PrivateRoute from "./PrivateRoute.js";
import jwtDecode from "jwt-decode";
import { refreshLoginAPI } from "./apis/apiAuth.js";
import UseScrollToTop from "./hooks/UseScrollToTop.js";
import Articles from "./pages/Articles.js";
import ArticleDetail from "./pages/ArticleDetail.js";

const AppRoutes = () => {
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    if (authCtx.token && authCtx.idUser) authCtx.initUser(authCtx.token, authCtx.idUser);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    async function fetchLocalData() {
      if (!authCtx || !authCtx.login) return;

      const storedToken = localStorage.getItem("idToken");
      const storedRefreshToken = localStorage.getItem("idRefreshToken");
      const storedIdUser = localStorage.getItem("idUser");

      if (storedRefreshToken && storedToken) {
        const decodedToken = jwtDecode(storedToken);
        const currentTime = Math.floor(Date.now() / 1000);
        const expirationTime = decodedToken.exp;

        if (expirationTime - currentTime < 3600) {
          try {
            const response = await refreshLoginAPI(storedRefreshToken);
            if (response.IdToken) {
              authCtx.login(response.IdToken, response.idUser, response.RefreshToken);
            }
          } catch (error) {
            console.error("Error refreshing token:", error);
          }
        } else {
          if (storedToken && storedIdUser) {
            authCtx.login(storedToken, storedIdUser, storedRefreshToken);
          }
        }
      }
    }

    fetchLocalData();
  }, [authCtx]);

  return (
    <Router basename="/" scrollRestoration="auto">
      <UseScrollToTop />
      <TopMenu />
      {/* <Banner /> */}
      {/* <div style={{paddingTop: 32}}> */}
      <div>
        <Routes >
          <Route path="/" element={<HomePage />} />

          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:id" element={<ArticleDetail />} />

          <Route path="/product/boitier-multifonction-securite-velo-trottinette-b01" element={<B01ProductPage />} />
          <Route path="/product/boitier-multifonction-securite-velo-trottinette-b01/:color" element={<B01ProductPage />} />
          <Route path="/product/boitier-multifonction-securite-velo-trottinette-b01-lite" element={<B01LiteProductPage />} />
          <Route path="/product/boitier-multifonction-securite-velo-trottinette-b01-lite/:color" element={<B01LiteProductPage />} />
          <Route path="/product/casque-intelligent-lumineux-h01" element={<H01ProductPage />} />
          <Route path="/product/casque-intelligent-lumineux-h01/:color" element={<H01ProductPage />} />
          {/* <Route path="/product/smartfix" element={<ProductDetailsPage />} />
          <Route path="/product/smartfix/:color" element={<ProductDetailsPage />} /> */}

          <Route path="/qr/notices-utilisation/:productId" element={<LanguageSelection />} />
          <Route path="/qr/notices-utilisation" element={<Notice />} />
          <Route path="/qr/notice" element={<Notice />} />
          <Route path="/content/6-notice" element={<Notice />} />

          <Route path="/login" element={<LoginPage />} />
          <Route path="/create-account" element={<CreateAccount />} />

          <Route path="/l-histoire-de-baltee-mobility" element={<BalteeStory />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/enterprise" element={<BusinessPage />} />
          <Route path="/cities" element={<CitiesPage />} />
          <Route path="/reseller" element={<ResellerPage />} />
          <Route path="/foire-aux-questions" element={<FAQPage />} />
          <Route path="/cgu" element={<CguPage />} />
          <Route path="/cgv" element={<CgvPage />} />
          <Route path="/legal-notice" element={<LegalNoticePage />} />
          <Route path="/rent-contract" element={<RentContract />} />

          <Route path="/checkout/cart" element={<CartPage />} />
          <Route path="/checkout/order-login" element={<OrderLoginPage />} />
          <Route path="/checkout/order-create-account" element={<OrderCreateAccount />} />
          <Route path="/checkout/shipping" element={<ShippingPage />} />
          <Route path="/checkout/shipping-address" element={<ShippingAddressPage />} />
          <Route path="/checkout/return" element={<CheckoutReturnPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />

          <Route path="/policies" element={<PoliciesPage />} />

          {/* Route protégée */}
          <Route element={<PrivateRoute isAuthenticated={authCtx.connected} redirect="/create-account" />}>
            <Route path="/account" element={<AccountPage />} />
          </Route>

          {/* Page 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      <FooterMenu />
    </Router>
  );
};

export default AppRoutes;
